import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IEnclosure } from '../../../shared/models/enclosure.model';
import { EnclosureType } from '../../../shared/models/prisma-xs.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-enclosure-information',
    templateUrl: './enclosure-information.component.html',
    styleUrls: ['./enclosure-information.component.scss'],
    standalone: false
})
export class EnclosureInformationComponent {
  @Input() enclosure: IEnclosure;
  enclosureTypes = EnclosureType;
}
